import React from 'react'

export const showSpinner=()=>{
  return <div className='popup-box text-center'>
    <div className='box'>
    <h6 className=" spin"></h6>
    </div>
    </div>
}

export const showSpinner1=()=>{
  return <div className="loader-outer">
  <div className="loader">
    <span className="dot dot-1"></span>
    <span className="dot dot-2"></span>
    <span className="dot dot-3"></span>
    <span className="dot dot-4"></span>
  </div>
</div>
}
export const showLoader =()=>{
 return <div className="loader">
   <div className="loading"></div>
   <div className="loading"></div>
   <div className="loading"></div>
   <div className="loading"></div>
   <div className="loading"></div>
   <div className="loading"></div>
</div>
}